/** Url del servicio webapi. */
export const BASE_URI = process.env.REACT_APP_WEBAPI_BASE_URI;

/** Timeout de conexión */
export const CONNECTION_TIMEOUT = 60000;
